import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { Y42EntityStore } from '@y42/state';
import { OrgState } from '../models/org.model';

const initialState: OrgState = {
  ui: {
    allJoinableOrgs: [],
  },
  active: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'org', idKey: 'id' })
export class OrgStore extends Y42EntityStore<OrgState> {
  constructor() {
    super(initialState);
  }

  updateUI(ui: OrgState['ui']): void {
    this.update((state) => ({
      ui: {
        ...state.ui,
        ...ui,
      },
    }));
  }
}
